import UserSetting, { IUserSettingApi, UserSettingKeys } from '@/common/models/user/UserSetting';
import Validatable from '@/validator/Validatable';

export interface IUserProfile {
  displayName: string;
  language: string;
  notificationPreferences: string;
  otherUserSettings: UserSetting[];
}

export interface IUserProfileApi {
  display_name: string;
  language: string;
  notification_preferences: string;
  other_user_settings: IUserSettingApi[];
}

export default class UserProfile extends Validatable {
  displayName: string;

  language: string;

  notificationPreferences: string;

  otherUserSettings: UserSetting[];

  constructor(displayName: string, language: string, notificationPreferences: string, otherUserSettings = []) {
    super();
    this.displayName = displayName;
    this.language = language;
    this.notificationPreferences = notificationPreferences;
    this.otherUserSettings = otherUserSettings;
  }

  getUserSettings(): UserSetting[] {
    return [
      ...(this.displayName != null ? [new UserSetting(UserSettingKeys.DISPLAY_NAME, this.displayName)] : []),
      ...(this.language != null ? [new UserSetting(UserSettingKeys.LANGUAGE, this.language)] : []),
      ...(this.notificationPreferences != null
        ? [new UserSetting(UserSettingKeys.NOTIFICATION_PREFERENCES, this.notificationPreferences)]
        : []),
      ...this.otherUserSettings,
    ];
  }

  static fromApi(apiObject: IUserProfileApi): UserProfile {
    return new UserProfile(
      apiObject.display_name,
      apiObject.language,
      apiObject.notification_preferences,
      apiObject.other_user_settings,
    );
  }

  static fromUserSettings(userSettings: UserSetting[]): UserProfile {
    return new UserProfile(
      userSettings.find((x) => x.key === UserSettingKeys.DISPLAY_NAME)?.value,
      userSettings.find((x) => x.key === UserSettingKeys.LANGUAGE)?.value,
      userSettings.find((x) => x.key === UserSettingKeys.NOTIFICATION_PREFERENCES)?.value,
      userSettings.filter((x) => !Object.keys(UserSettingKeys).includes(x.key)),
    );
  }

  toApi(): IUserProfileApi {
    return {
      display_name: this.displayName,
      language: this.language,
      notification_preferences: this.notificationPreferences,
      other_user_settings: this.otherUserSettings,
    };
  }

  static fromObject(obj: IUserProfile): UserProfile {
    return super.fromObject(obj, new UserProfile());
  }
}
